import { render, staticRenderFns } from "./comparacion.vue?vue&type=template&id=f2f47124&scoped=true&"
import script from "./comparacion.vue?vue&type=script&lang=js&"
export * from "./comparacion.vue?vue&type=script&lang=js&"
import style0 from "./comparacion.vue?vue&type=style&index=0&id=f2f47124&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f47124",
  null
  
)

export default component.exports